module.exports = __webpack_public_path__ + "static/img/13.5a18813.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/zh/13.png
// module id = Ocw1
// module chunks = 0